import React from 'react';
import { AccordionItem } from './ui/Accordion';
import { Button } from './ui/Button';
import { CHECKOUT_URL } from './data';
const faqs = [{
  q: '¿Sirve si soy principiante?',
  a: 'Absolutamente. El sistema está diseñado para construir una base sólida desde cero, previniendo lesiones que suelen sufrir los novatos por falta de preparación física adecuada.'
}, {
  q: '¿Necesito gimnasio o mucho equipamiento?',
  a: 'La mayoría de los ejercicios de fuerza requieren equipamiento básico de gimnasio (barras, mancuernas, kettlebells), pero los módulos de movilidad, calentamiento y prevención se pueden hacer en casa o en la misma academia antes de clase.'
}, {
  q: '¿Y si no tengo tiempo?',
  a: 'El sistema incluye rutinas express (de 2 a 10 minutos) y planificadores para adaptar el entrenamiento a tu disponibilidad, incluso si solo tienes 2 o 3 días a la semana para entrenar físico.'
}, {
  q: '¿Es solo para BJJ o también MMA?',
  a: 'Cubre ambas disciplinas a la perfección. Hay tomos específicos para las demandas del grappling (BJJ) y del striking/clinch (MMA), permitiéndote armar la rutina que mejor se adapte a tu deporte principal.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'El acceso es 100% digital e inmediato. Al realizar la compra segura, recibirás automáticamente un correo electrónico con el enlace para descargar todos los PDFs y las planillas de Excel a tu celular o computadora.'
}];
export function Objections() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-67">
      <div className="text-center mb-12" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-69">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="mb-16" data-id="element-70">
        {faqs.map((faq, i) => <AccordionItem key={i} title={faq.q} data-id="element-71">
            <p className="text-zinc-300 leading-relaxed" data-id="element-72">{faq.a}</p>
          </AccordionItem>)}
      </div>

      <div className="text-center" data-id="element-73">
        <p className="text-xl text-white mb-6 font-medium" data-id="element-74">
          ¿Listo para transformar tu rendimiento en el tatami?
        </p>
        <Button href={CHECKOUT_URL} className="text-xl py-5 px-10" data-id="element-75">
          Sí, quiero el sistema completo
        </Button>
      </div>
    </section>;
}